module.exports = __webpack_public_path__ + "img/promo-banner2.1b483b77.png";